"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionStatus = exports.SubmissionType = void 0;
var SubmissionType;
(function (SubmissionType) {
    SubmissionType["SUGGEST_EDIT"] = "suggest_edit";
    SubmissionType["NEW_VENUE"] = "new_venue";
})(SubmissionType = exports.SubmissionType || (exports.SubmissionType = {}));
var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["PENDING"] = "pending";
    SubmissionStatus["APPROVED"] = "approved";
    SubmissionStatus["REJECTED"] = "rejected";
})(SubmissionStatus = exports.SubmissionStatus || (exports.SubmissionStatus = {}));
